import { FormattedMessage } from '@flipster/i18n';
import TelegramIcon from '@flipster/react/icon/generated/TelegramIcon';
import TwitterIcon from '@flipster/react/icon/generated/TwitterIcon';
import YoutubeIcon from '@flipster/react/icon/generated/YoutubeIcon';

export const socialProviders = {
  X: {
    label: 'X (Twitter)',
    suffix: <FormattedMessage id='Common.r251107.Followers' />,
    Icon: TwitterIcon,
  },
  TELEGRAM: {
    label: 'Telegram',
    suffix: <FormattedMessage id='Common.r251107.Members' />,
    Icon: TelegramIcon,
  },
  YOUTUBE: {
    label: 'YouTube',
    suffix: <FormattedMessage id='Common.r251107.Subscribers' />,
    Icon: YoutubeIcon,
  },
};
